<template>
  <div>
    <empty-card
      :table="true"
      :title="$t('reply.menu-enabled')"
    >
      <template
        v-if="!forAdmin"
        slot="title"
      >
        <b-button
          size="md"
          variant="dark"
          class="mx-md-1"
          @click="$router.push({name:'owner:posts'})"
        >
          {{ $t('reply.enable-new') }}
        </b-button>
      </template>
      <ok-table
        ref="datatable"
        :config="tableConfig"
        @edit="goEdit"
        @delete="handleDelete"
      >
        <template
          slot="post-column"
          slot-scope="{props}"
        >
          <a
            :href="props.row.post_url"
            target="_blank"
          >
            {{ props.row.description }}
          </a>
        </template>
        <template
          slot="status-column"
          slot-scope="{props}"
        >
          <b-badge :variant="getStatusVariant(props.row)">
            {{ getStatusText(props.row) }}
          </b-badge>
        </template>
        <template
          slot="type-column"
          slot-scope="{props}"
        >
          <b-badge variant="primary">
            {{ $t(`reply.${props.row.type}`) }}
          </b-badge>
        </template>
        <template
          slot="account-column"
          slot-scope="{props}"
        >
          <b-badge variant="primary">
            <span v-if="props.row.account_name">
              {{ props.row.account_name }}
            </span>
            <span v-else>
              الافتراضي
            </span>
          </b-badge>
        </template>
        <template
          slot="multi_account-column"
          slot-scope="{props}"
        >
          <b-badge variant="primary">
            <span v-if="props.row.multi_account_name">
              {{ props.row.multi_account_name }}
            </span>
            <span v-else>
              الافتراضي
            </span>
          </b-badge>
        </template>
        <template
          slot="actions-column"
          slot-scope="{props}"
        >
          <custom-actions>
            <b-dropdown-item
              @click.stop="goEdit(props)"
            >
              <feather-icon
                icon="Edit2Icon"
                class="mr-50"
              />
              <span>{{ $t('forms.edit') }}</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="props.row.status!==1"
              @click.stop="handleChangeStatus(props)"
            >
              <feather-icon
                :icon="props.row.status===0?'PauseIcon':'PlayIcon'"
                class="mr-50"
              />
              <span>{{ $t(`reply.${props.row.status===0?'stop':'start'}`) }}</span>
            </b-dropdown-item>
            <b-dropdown-item
              v-if="forAdmin"
              @click.stop="handleReplyOldComments(props)"
            >
              <feather-icon
                icon="MessageCircleIcon"
                class="mr-50"
              />
              <span>{{ $t('reply.reply-old-comments') }}</span>
            </b-dropdown-item>
          </custom-actions>
        </template>
      </ok-table>
    </empty-card>
  </div>
</template>

<script>
import { BBadge, BButton, BDropdownItem } from 'bootstrap-vue'
import { mapGetters } from 'vuex'
import EmptyCard from '@/@bya3/components/cards/EmptyCard'
import OkTable from '@/@bya3/components/tables/ok-table/OkTable'
import ReplyApi from '@/api/reply'
import CustomActions from '@/@bya3/components/tables/ok-table/components/CustomActions'

export default {
  components: {
    CustomActions,
    EmptyCard,
    OkTable,
    BBadge,
    BButton,
    BDropdownItem,
  },
  props: {
    config: {
      type: Object,
      default: () => {},
    },
    forAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showOrdersModal: false,
      selectedClient: {},
    }
  },
  computed: {
    ...mapGetters({
      currentPageId: 'pages/currentPageId',
      currentPage: 'pages/currentPage',
    }),
    isCommentAlogEnabled() {
      return this.currentPage?.comment_algo_enable ?? 0
    },
    tableConfig() {
      const { config } = this
      if (!this.isCommentAlogEnabled) return config
      const algoIndex = config.columns.findIndex(col => col?.field === 'account')
      if (algoIndex > -1) {
        config.columns[algoIndex].hidden = false
      }
      if (this.currentPage?.max_comments > 1) {
        const algoMultiIndex = config.columns.findIndex(col => col?.field === 'multi_account')
        if (algoMultiIndex > -1) {
          config.columns[algoMultiIndex].hidden = false
        }
      }
      return config
    },
  },
  watch: {
    currentPageId() {
      if (!this.forAdmin) this.refreshTable()
    },
  },

  methods: {
    refreshTable() {
      this.showOrdersModal = false
      this.selectedClient = {}
      this.$refs.datatable.loadItems()
    },
    openOrdersModal(data) {
      if (!data.row?.orders?.length) return
      this.showOrdersModal = true
      this.selectedClient = data.row
    },
    getStatusVariant(report) {
      if (this.currentPage.package.count < report.replies_count) return 'danger'
      switch (report.status) {
        case 1: return 'danger'
        case 2: return 'warning'
        default: return 'success'
      }
    },
    getStatusText(report) {
      if (this.currentPage.package.count < report.replies_count) return this.$t('reply.is_enable_message')
      switch (report.status) {
        case 1: return this.$t('reply.stopped')
        case 2: return this.$t('reply.temp_stop')
        default: return this.$t('reply.running')
      }
    },
    goEdit(props) {
      this.$router.push({ name: 'owner:reply-edit', params: { id: props.row.post_id } })
    },
    handleDelete(data) {
      this.$okConfirm(this.$t('reply.delete-reply-message'), {
        preConfirm: () => ReplyApi.deleteReply(data.row.post_id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handleChangeStatus(data) {
      const label = data.row.status === 0 ? 'stop' : 'start'
      this.$okConfirm(this.$t(`reply.${label}-reply-message`), {
        confirmButtonText: this.$t('forms.submit'),
        showCancel: true,
        preConfirm: () => ReplyApi.changeReplyStatus(data.row.post_id)
          .then(response => {
            this.$notifySuccess(response.message)
            this.refreshTable()
          })
          .catch(e => this.$notifyError(e)),
      })
    },
    handleReplyOldComments(data) {
      const self = this
      this.$swal.fire({
        title: self.$t('reply.reply-old-comments'),
        text: self.$t('reply.reply-old-comments-hint'),
        input: 'number',
        inputValue: 100,
        inputAttributes: {
          min: 1,
          max: 1000,
          step: 1,
        },
        showCancelButton: true,
        confirmButtonText: self.$t('forms.submit'),
        cancelButtonText: self.$t('forms.cancel'),
        showLoaderOnConfirm: true,
        inputValidator: value => {
          const n = parseInt(value, 10)
          if (!n || n < 1 || n > 1000) {
            return self.$t('reply.reply-old-comments-limit-invalid')
          }
          return null
        },
        preConfirm: async limit => {
          try {
            const response = await ReplyApi.replyOldComments(data.row.id, parseInt(limit, 10))
            if (response.error === 1) {
              return self.$swal.showValidationMessage(response.message ?? '')
            }
            return response
          } catch (error) {
            return self.$swal.showValidationMessage(`${error}`)
          }
        },
        allowOutsideClick: () => !self.$swal.isLoading(),
      }).then(result => {
        if (result.isConfirmed && result.value) {
          self.$notifySuccess(result.value.message)
        }
      })
    },
  },
}
</script>
